import React from "react";
import datasetParser from "@Dataset/datasetParser";
import StopInfoFragment from "@Pages/stationPage/components/StopInfoFragment";
import Portal from "@Portals/components/Portal";
import IconLocationMarker from "@Icons/IconLocationMarker";
import {useTranslation} from "@Translation/hooks/useTranslation";
import useLocale from "@Hooks/selector/useLocale";
import {Colors} from "@Styles/Colors.style";

const DepartureAndDestinationStation = () => {
    const data = datasetParser({id: "departure-and-destination-station-portal"})

    if (!data) {
        return (
            <></>
        )
    }

    const {
        departureStation,
        destinationStation,
        departureStationLink,
        destinationStationLink,
        departureRating,
        destinationRating,
        clickToOpen,
    } = data

    const locale = useLocale();

    const seeInfo = useTranslation("sts_page.information")
    const seeInfoReturn = useTranslation("sts_page.information_return")
    const here = useTranslation("sts_page.here")

    const departureGMapsLink = `https://www.google.com/maps/search/?api=1&query=${departureStation?.Latitude}%2C${departureStation?.Longitude}`
    const destinationGMapsLink = `https://www.google.com/maps/search/?api=1&query=${destinationStation?.Latitude}%2C${destinationStation?.Longitude}`

    return (
        <Portal id="departure-and-destination-station-portal">
            <div className="stop-information-grid">
                <StopInfoFragment
                    label={departureStation[`Name${locale.replace('-', '_').toUpperCase()}`]}
                    icon={<IconLocationMarker fill={Colors.primaryColor}/>}
                    rating={departureRating}
                >
                    {departureStationLink && (
                        <span className="stop-information-field-value">
                            {seeInfo}
                            {' '}
                            {departureStation[`Name${locale.replace('-', '_').toUpperCase()}`]}
                            {' '}
                            {' '}
                            <a href={departureStationLink}>{here}</a>
                            .
                        </span>
                    )}
                    {!departureStationLink && (
                        <a href={departureGMapsLink} target="_blank" rel="noreferrer">
                            {clickToOpen}
                        </a>
                    )}
                </StopInfoFragment>

                <StopInfoFragment
                    label={destinationStation.Name}
                    icon={<IconLocationMarker fill={Colors.primaryColor}/>}
                    rating={destinationRating}
                >
                    {destinationStationLink && (
                        <span className="stop-information-field-value">
                            {seeInfoReturn}
                            {' '}
                            {destinationStation.Name}
                            {' '}
                            {' '}
                            <a href={destinationStationLink}>{here}</a>
                            .
                        </span>
                    )}
                    {!destinationStationLink && (
                        <a href={destinationGMapsLink} target="_blank" rel="noreferrer">
                            {clickToOpen}
                        </a>
                    )}
                </StopInfoFragment>
            </div>
        </Portal>
    )
}

export default DepartureAndDestinationStation;